module.exports = __webpack_public_path__ + "static/media/Square.1d840410.png";